import { DeviceInfo } from '@/hooks/useDeviceInfo';

export const logDeviceInfo = (deviceInfo: DeviceInfo) => {
  const deviceData = {
    // Основная информация
    deviceType: deviceInfo.isMobile ? 'mobile' : deviceInfo.isTablet ? 'tablet' : 'desktop',
    os: deviceInfo.isIOS ? 'ios' : 
        deviceInfo.isAndroid ? 'android' : 
        deviceInfo.isWindows ? 'windows' : 
        deviceInfo.isMac ? 'macos' : 
        deviceInfo.isLinux ? 'linux' : 'unknown',
    browser: deviceInfo.browser.toLowerCase(),
    browserVersion: deviceInfo.browserVersion,
    
    // Характеристики экрана
    screenResolution: `${deviceInfo.screenWidth}x${deviceInfo.screenHeight}`,
    viewportSize: `${deviceInfo.viewportWidth}x${deviceInfo.viewportHeight}`,
    pixelRatio: deviceInfo.pixelRatio,
    
    // Возможности устройства
    isTouchDevice: deviceInfo.isTouchDevice,
    orientation: deviceInfo.isLandscape ? 'landscape' : 'portrait',
    
    // Timestamp
    timestamp: new Date().toISOString()
  };

  // Логируем в консоль для разработки
  if (process.env.NODE_ENV === 'development') {
    console.log('Device Info:', deviceData);
  }

  // Здесь можно отправить данные в аналитику
  // Например: analytics.track('device_info', deviceData);
  
  return deviceData;
};

export const getDeviceSummary = (deviceInfo: DeviceInfo): string => {
  const deviceType = deviceInfo.isMobile ? 'Mobile' : deviceInfo.isTablet ? 'Tablet' : 'Desktop';
  const os = deviceInfo.isIOS ? 'iOS' : 
             deviceInfo.isAndroid ? 'Android' : 
             deviceInfo.isWindows ? 'Windows' : 
             deviceInfo.isMac ? 'macOS' : 
             deviceInfo.isLinux ? 'Linux' : 'Unknown';
  
  return `${deviceType} - ${os} - ${deviceInfo.browser} ${deviceInfo.browserVersion}`;
};

export const isSupportedBrowser = (deviceInfo: DeviceInfo): boolean => {
  // Проверяем поддержку основных браузеров
  return deviceInfo.isChrome || 
         deviceInfo.isFirefox || 
         deviceInfo.isSafari || 
         deviceInfo.isEdge;
};

export const isMobileDevice = (deviceInfo: DeviceInfo): boolean => {
  return deviceInfo.isMobile || deviceInfo.isTablet;
};

export const getDeviceCapabilities = (deviceInfo: DeviceInfo) => {
  return {
    canInstallPWA: deviceInfo.isChrome || deviceInfo.isFirefox || deviceInfo.isEdge,
    supportsTouch: deviceInfo.isTouchDevice,
    supportsHighDPI: deviceInfo.pixelRatio > 1,
    isRetina: deviceInfo.pixelRatio >= 2,
    supportsOrientation: deviceInfo.isMobile || deviceInfo.isTablet
  };
}; 